export default {
  CUSTOM: "custom",
  DEVICE_LICENSE: "device_license",
  SMS_DEVICE: "sms_device",
  SMS_EXTERNAL: "sms_external"
};
